// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#tvmServiceCoupons :deep(.modal) {
  position: absolute !important;
  margin: 10px;
}
#tvmServiceCoupons :deep(.modal-body) {
  padding: 0px;
}
#tvmServiceCoupons :deep(.modal-header) {
  padding: 5px;
}
#tvmServiceCoupons :deep(.modal-title) {
  text-transform: capitalize;
}
#tvmServiceCoupons:deep(.modal-backdrop) {
  position: absolute !important;
}
.ai_offer_img img {
  height: 150px;
  object-fit: cover;
  border-radius: 6px;
  width: 100%;
}
.card-min-height {
  min-height: 200px;
}
.page_counter {
  position: absolute;
  right: 2%;
  bottom: 2%;
  font-weight: bold;
  border-left: 1px solid #e1e1e1d7;
  padding-left: 10px;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiServiceCoupons.vue","webpack://./AiServiceCoupons.vue"],"names":[],"mappings":"AACA;EACE,6BAAA;EACA,YAAA;ACAF;ADGA;EACE,YAAA;ACDF;ADIA;EACE,YAAA;ACFF;ADKA;EACE,0BAAA;ACHF;ADMA;EACE,6BAAA;ACJF;ADQA;EAEI,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;ACPJ;ADWA;EACE,iBAAA;ACTF;ADYA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,cAAA;ACVF","sourcesContent":["\n#tvmServiceCoupons :deep(.modal) {\n  position: absolute !important;\n  margin: 10px;\n}\n\n#tvmServiceCoupons :deep(.modal-body) {\n  padding: 0px;\n}\n\n#tvmServiceCoupons :deep(.modal-header) {\n  padding: 5px;\n}\n\n#tvmServiceCoupons :deep(.modal-title) {\n  text-transform: capitalize;\n}\n\n#tvmServiceCoupons:deep(.modal-backdrop) {\n  position: absolute !important;\n}\n\n\n.ai_offer_img {\n  img {\n    height: 150px;\n    object-fit: cover;\n    border-radius: 6px;\n    width: 100%;\n  }\n}\n\n.card-min-height {\n  min-height: 200px;\n}\n\n.page_counter {\n  position: absolute;\n  right: 2%;\n  bottom: 2%;\n  font-weight: bold;\n  border-left: 1px solid #e1e1e1d7;\n  padding-left: 10px;\n  line-height: 1;\n}\n","#tvmServiceCoupons :deep(.modal) {\n  position: absolute !important;\n  margin: 10px;\n}\n#tvmServiceCoupons :deep(.modal-body) {\n  padding: 0px;\n}\n#tvmServiceCoupons :deep(.modal-header) {\n  padding: 5px;\n}\n#tvmServiceCoupons :deep(.modal-title) {\n  text-transform: capitalize;\n}\n#tvmServiceCoupons:deep(.modal-backdrop) {\n  position: absolute !important;\n}\n.ai_offer_img img {\n  height: 150px;\n  object-fit: cover;\n  border-radius: 6px;\n  width: 100%;\n}\n.card-min-height {\n  min-height: 200px;\n}\n.page_counter {\n  position: absolute;\n  right: 2%;\n  bottom: 2%;\n  font-weight: bold;\n  border-left: 1px solid #e1e1e1d7;\n  padding-left: 10px;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
